<script>
  import { Button } from "paxray-components-svelte";

  // Shown instead of the list once every entry of this level is checked.
  // level: "masks" or "elements", progress: result of loadAnonymizationCheckProgress.
  export let level = "masks";
  export let progress = null;
  export let onSwitchLevel = () => {};
  export let onShowChecked = () => {};

  $: otherLevel = level === "masks" ? "elements" : "masks";
  $: otherCounts = level === "masks" ? progress?.uiElements : progress?.windowTitles;
  $: otherOpen = otherCounts ? otherCounts.total - otherCounts.checked : 0;

  $: title = otherOpen > 0 ? `All ${level} are checked.` : "Everything is checked.";
  $: hint =
    otherOpen > 0
      ? `${otherOpen} ${otherOpen === 1 ? otherLevel.slice(0, -1) + " is" : otherLevel + " are"} still open.`
      : progress?.checkCompleted
        ? "The anonymization check is complete."
        : progress?.registrationEnded
          ? "You can now complete the anonymization check."
          : "New entries can still come in while task registration is running.\nYou can complete the check once task registration has ended.";
</script>

<!-- Same look as the SectionWrapper empty state, with a green check instead of the info icon.
     Icon and text share the first row, the buttons sit below the text, and the whole group is centered. -->
<div class="done_state">
  <div class="done_group">
    <div class="done_icon" aria-hidden="true">
      <img src="/img/assistant/icons/check.svg" alt="" />
    </div>
    <div class="done_text">
      <div class="done_title">{title}</div>
      <div class="done_hint">{hint}</div>
    </div>
    <div class="done_actions">
      {#if otherOpen > 0}
        <Button
          text={`Go to ${otherLevel}`}
          kind="secondary"
          size="field"
          on:click={onSwitchLevel}
        />
      {/if}
      <Button
        text="Show checked entries"
        kind={otherOpen > 0 ? "outline-dark" : "secondary"}
        size="field"
        on:click={onShowChecked}
      />
    </div>
  </div>
</div>

<style>
  .done_state {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    min-height: 20rem;
    width: 100%;
  }

  .done_group {
    align-items: center;
    column-gap: 1rem;
    display: grid;
    grid-template-columns: 3rem auto;
    row-gap: 1rem;
  }

  .done_icon {
    align-items: center;
    background: var(--pax-green-new);
    border-radius: 50%;
    display: flex;
    height: 3rem;
    justify-content: center;
    width: 3rem;
  }

  .done_icon img {
    display: block;
    filter: brightness(0);
    height: 1.5rem;
    width: 1.5rem;
  }

  .done_title,
  .done_hint {
    font-size: 1rem;
  }

  .done_title {
    color: var(--pax-black);
  }

  .done_hint {
    color: var(--pax-grey);
    margin-top: 0.5rem;
    white-space: pre-line;
  }

  .done_actions {
    display: flex;
    gap: var(--control-gap);
    grid-column: 2;
    white-space: nowrap;
  }
</style>
